import { render, staticRenderFns } from "./ApprovedOldAqs.vue?vue&type=template&id=057971a4"
import script from "./ApprovedOldAqs.vue?vue&type=script&lang=js"
export * from "./ApprovedOldAqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports